<template>
  <div v-if="!!phaseData">
    <div>
      <div class="d-flex align-center justify-space-between" :class="{ 'mt-4': $vuetify.breakpoint.smAndDown }">
        <div class="d-flex align-center">
          <div class="mb-0 mr-2" v-if="$vuetify.breakpoint.mdAndUp">Formato da calculadora:</div>
          <div>
            <v-btn-toggle
              v-model="showImages"
              rounded
              active-class="bg-active"
              dense
              background-color="white"
              @change="$emit('btn:toggle', showImages ? 'IMAGEM' : 'NUMERO')"
            >
              <v-btn
                :value="true"
                depressed
                :class="['text-none', { 'bg-active': showImages, 'bg-inactive': !showImages }]"
              >
                <v-icon size="18" class="pa-2" v-if="showImages">mdi-check</v-icon>
                Imagem
              </v-btn>
              <v-btn
                :value="false"
                depressed
                :class="['text-none', { 'bg-active': !showImages, 'bg-inactive': showImages }]"
              >
                <v-icon size="18" class="pa-2" v-if="!showImages">mdi-check</v-icon>
                Número
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>
        <div>
          <v-btn-toggle
            v-model="phaseData.resultado_manual"
            background-color="white"
            @change="$emit('btn:toggle', phaseData.resultado_manual)"
          >
            <v-btn
              :value="true"
              depressed
              :class="[
                'text-none',
                { 'bg-active': phaseData.resultado_manual, 'bg-inactive': !phaseData.resultado_manual },
              ]"
            >
              Aplicar resultado manualmente
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>

      <div
        v-if="phaseData.resultado_manual"
        class="mt-4 d-flex flex-row"
        :class="{ 'flex-column gap-8': $vuetify.breakpoint.smAndDown, 'gap-12': !$vuetify.breakpoint.smAndDown }"
      >
        <field-label v-for="indicator in indicators" :key="indicator.key" :label="indicator.name">
          <div class="d-flex gap-2 mt-2 align-center">
            <text-field :min="0" type="number" v-model="phaseData[indicator.key]" :max="indicator.max" />
          </div>
        </field-label>
      </div>

      <div v-else>
        <SideResult
          title=""
          :show-buttons="false"
          direction="row"
          :metrics="paramData"
          :compact="$vuetify.breakpoint.smAndDown"
        />

        <PasiBsaCalculator
          :showImages="showImages"
          v-model="paramData"
          :fillData="{
            cabeca_pescoco: this.phaseData.cabeca_pescoco,
            tronco: this.phaseData.tronco,
            membros_superiores: this.phaseData.membros_superiores,
            membros_inferiores: this.phaseData.membros_inferiores,
          }"
          @input="updatePhaseData"
          @calculate="onCalculate"
          class="w-full py-8 border-r with-scroll"
        />
      </div>

      <attendance-step-note class="mt-8 py-2" />
    </div>
    <reference-image-dialog ref="referenceImageDialog" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import TextField from '@/components/TextField.vue'
import ReferenceImageDialog from '@/components/AttendanceForm/ReferenceImageDialog.vue'
import SideResult from '@/components/CalculatorContent/partial/SideResult.vue'
import PasiBsaCalculator from '@/components/CalculatorContent/PASIBSA.vue'
import AttendanceStepNote from '@/components/AttendanceForm/psoriasis/phase/v2/AttendanceStepNote.vue'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  extends: BasePhase,
  components: { AttendanceStepNote, PasiBsaCalculator, SideResult, FieldLabel, TextField, ReferenceImageDialog },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
  },
  data() {
    return {
      paramData: [],
      showImages: true,
      indicators: [
        {
          key: 'pasi',
          name: 'PASI',
          max: 72,
        },
        {
          key: 'bsa',
          name: 'BSA',
          max: 100,
        },
      ],
    }
  },
  mounted() {
    if (this.predominantSymptom !== this.phaseData.predominantSymptom) {
      this.phaseData = this.getDefaultData()
      this.phaseData.predominantSymptom = this.predominantSymptom
    }
  },
  methods: {
    updatePhaseData(data) {
      data.forEach((d) => (this.phaseData[d.key] = d.value))
    },
    onCalculate(data) {
      const { cabeca_pescoco, tronco, membros_superiores, membros_inferiores } = data
      this.phaseData = {
        ...this.phaseData,
        cabeca_pescoco,
        tronco,
        membros_superiores,
        membros_inferiores,
      }
    },
    getDefaultData() {
      return {
        pasi: null,
        bsa: null,
        resultado_manual: false,
        cabeca_pescoco: {
          eritema: null,
          descamacao: null,
          infiltracao: null,
          area: 0,
        },
        tronco: {
          eritema: null,
          descamacao: null,
          infiltracao: null,
          area: 0,
        },
        membros_superiores: {
          eritema: null,
          descamacao: null,
          infiltracao: null,
          area: 0,
        },
        membros_inferiores: {
          eritema: null,
          descamacao: null,
          infiltracao: null,
          area: 0,
        },
        notes: null,
      }
    },
  },
}
</script>

<style scoped>
.big-number {
  font-weight: medium;
  color: green;
  font-size: 2.5rem;
}

.area-box {
  border: 1px solid grey;
  border-radius: 10px;
}

.slider-image {
  border: 4px solid #1976d2;
}

.area-component.small :deep(.col) {
  flex-basis: auto !important;
}

.bg-active {
  background-color: #e0f0ff !important;
  opacity: 1 !important;
}

.bg-inactive {
  background-color: #ffffff !important;
}

.v-btn.v-item--active::before {
  background-color: #ffffff;
}
</style>
